import { Visibility } from '@/utils/api'
import removeNullishValues from '@/utils/removeNullishValues'

export const resolveArchiveStatus = (vis?: Visibility | null) =>
  vis ?? Visibility.active

export const getArchiveSearchParams = (vis?: Visibility | null) =>
  removeNullishValues({ archiveStatus: resolveArchiveStatus(vis) })
